import Storage from 'utils/Storage';
import handlePromise from 'utils/Promise';
import { isSsoEnabled } from 'utils/authMode';
import AuthService from 'services/api/Auth';
import { logoutUser } from 'store/User';

type Dispatch = ( action: ReturnType<typeof logoutUser> ) => void;

type ClearAuthSessionOptions = {
  clearPersist?: boolean;
};

/**
 * Borra la sesión local: access, refresh y usuario de Redux. No avisa al SSO.
 * El refresh se borra siempre: si quedara en `localStorage` seguiría siendo válido en el SSO.
 */
export default function clearAuthSession(
  dispatch?: Dispatch,
  { clearPersist = true }: ClearAuthSessionOptions = {},
) {
  Storage.clear( 'grupoimpar:token' );
  Storage.clear( 'grupoimpar:refreshToken' );
  if ( clearPersist ) {
    Storage.clear( 'persist:grupoimpar' );
  }
  dispatch?.( logoutUser() );
}

/**
 * Logout único de la app (cabeceras de usuario y admin, menú lateral): revoca la sesión en el SSO
 * con el body `{ accessToken, revokeAll: false }` y después borra la sesión local, aunque el SSO
 * falle.
 * Con el access ya caducado el SSO no puede revocar; la sesión local se borra igual.
 */
export async function logoutSession(
  dispatch?: Dispatch,
  options: ClearAuthSessionOptions = {},
) {
  const accessToken = Storage.get( 'grupoimpar:token' );
  if ( isSsoEnabled() && accessToken ) {
    await handlePromise( AuthService.ssoLogout( {
      accessToken,
      revokeAll: false,
    } ) );
  }
  clearAuthSession( dispatch, options );
}
